import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../../../core/common/crmComponents/PageHeader";
import { IoIosArrowRoundBack } from "react-icons/io";
import { all_routes } from "../../../router/all_routes";

const ZoomIntegration = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <PageHeader pageName="Configure Zoom">
            <button
              className="p-2 btn btn-outline-none"
              onClick={() => navigate(all_routes.integrations)}
            >
              <IoIosArrowRoundBack className="d-inline" size={20} />
            </button>
          </PageHeader>
          <p>
            Here you can configure the settings for <strong>Zoom</strong>.
          </p>
          {/* Add specific configuration details here */}
        </div>
      </div>
    </>
  );
};

export default ZoomIntegration;
